module.exports = __webpack_public_path__ + "img/button_up.b18991ed.svg";